<template>
  <div id="app" ref="app">
    <router-view />
    <transition name="fade" v-if="showSidebar">
      <sidebar :component="sidebarComponent" />
    </transition>
    <transition name="fade" v-if="showModal">
      <modal :component="modalComponent" />
    </transition>
    <overlay v-if="showOverlay" :component="overlayComponent" />
    <transition name="slide-down">
      <dropdown-noti v-if="showDropdownNoti" v-bind="dropdownNotiComponent" />
    </transition>
    <transition name="slide-down">
      <user-offline v-if="!isOnline" />
    </transition>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandlerModal from "@/components/shared/Modals/ErrorHandlerModal";
import UserOffline from "@/elements/notifications/UserOffline";
// import notifyMe from "@/assets/utils/notificationService";
export default {
  name: "App",
  components: {
    UserOffline
  },
  data() {
    return {
      showSidebar: false,
      sidebarComponent: undefined,
      showModal: false,
      modalComponent: undefined,
      showOverlay: false,
      overlayComponent: undefined,
      showDropdownNoti: false,
      dropdownNotiComponent: undefined,
      isOnline: true
    };
  },
  mounted() {
    // notifyMe();
    this.$moment.locale("hu");
    this.isOnline = navigator.onLine;
    const loadingScreen = document.getElementById("loading-screen");
    loadingScreen.style.display = "none";
    this.subscribeEvents();
  },
  beforeDestroy() {
    this.unsubscribeEvents();
  },
  computed: {
    ...mapGetters({
      getErrorMessage: "errorHandler/getErrorMessage",
      getActiveUser: "user/getActiveUser"
    })
  },
  watch: {
    $route() {
      this.$eventBus.closeSidebar();
      this.$eventBus.closeModal();
      this.$eventBus.closeOverlay();
    },
    "getErrorMessage.required"() {
      if (this.getErrorMessage && this.getErrorMessage.required === true) {
        this.$eventBus.showModal({
          title: this.$t("errorHandlerModal.title"),
          bind: {
            is: ErrorHandlerModal,
            text: this.$t("errorHandlerModal.text"),
            okText: this.$t("errorHandlerModal.okButton.text"),
            width: "450px"
          }
        });
      }
    }
  },
  methods: {
    ...mapActions({
      setWindowWidth: "layout/setWindowWidth"
    }),
    addBackgroundBlur() {
      if (document.getElementById("logged-in-layout"))
        document
          .getElementById("logged-in-layout")
          .classList.add("blur-background");
    },
    removeBackgroundBlur() {
      if (document.getElementById("logged-in-layout")) {
        document
          .getElementById("logged-in-layout")
          .classList.remove("blur-background");
      }
    },
    updateOnlineStatus(isOnline) {
      this.isOnline = isOnline;
    },
    handleResize() {
      this.setWindowWidth(window.innerWidth);
    },
    afterPopperEnter() {
      document.body.classList.add("no-scroll");
      document.body.style.position = "fixed";
      document.body.style.top = `-${window.scrollY}px`;
    },
    beforePopperLeave() {
      document.body.classList.remove("no-scroll");
      const scrollY = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    },
    unsubscribeEvents() {
      window.removeEventListener("online", this.updateOnlineStatus);
      window.removeEventListener("offline", this.updateOnlineStatus);
      this.$eventBus.offShowSidebar();
      this.$eventBus.offCloseSidebar();
      this.$eventBus.offShowModal();
      this.$eventBus.offCloseModal();
      this.$eventBus.offShowOverlay();
      this.$eventBus.offCloseOverlay();
      this.$eventBus.offShowDropdownNoti();
      this.$eventBus.offCloseDropdownNoti();
    },
    subscribeEvents() {
      this.$eventBus.onShowSidebar(this, payload => {
        this.showSidebar = true;
        this.addBackgroundBlur();
        this.sidebarComponent = payload;
      });
      this.$eventBus.onCloseSidebar(this, () => {
        this.showSidebar = false;
        this.removeBackgroundBlur();
        this.sidebarComponent = undefined;
      });
      this.$eventBus.onShowModal(this, payload => {
        this.showModal = true;
        this.afterPopperEnter();
        this.addBackgroundBlur();
        this.modalComponent = payload;
      });
      this.$eventBus.onCloseModal(this, () => {
        this.showModal = false;
        this.modalComponent = undefined;
        this.beforePopperLeave();
        this.removeBackgroundBlur();
      });
      this.$eventBus.onShowOverlay(this, payload => {
        this.showOverlay = true;
        this.afterPopperEnter();
        this.overlayComponent = payload;
      });
      this.$eventBus.onCloseOverlay(this, () => {
        this.showOverlay = false;
        this.overlayComponent = undefined;
        this.beforePopperLeave();
      });
      this.$eventBus.onShowDropdownNoti(this, payload => {
        if (!this.showDropdownNoti) {
          this.showDropdownNoti = true;
          this.dropdownNotiComponent = payload;
        }
      });
      this.$eventBus.onCloseDropdownNoti(this, () => {
        this.showDropdownNoti = false;
        this.dropdownNotiComponent = undefined;
      });
      window.addEventListener("resize", this.handleResize);
      window.addEventListener("online", () => {
        this.updateOnlineStatus(true);
      });
      window.addEventListener("offline", () => {
        this.updateOnlineStatus(false);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
#app {
  overflow: hidden;
}
</style>
